import React from 'react'
import { compose, setDisplayName, withProps } from 'recompose'
import { setPropTypes, PropTypes } from 'proper-types'
import omitProps from '@hocs/omit-props'

import {
  AlertBannerWarning,
  ButtonPrimary,
  ButtonSecondary,
  IconBackNavigation,
  ParagraphSecondary,
  SpacerVertical,
  TitlePrimary,
  View,
} from '@klarna/bubble-ui'

import { codes } from './constants'

const getIds = ({ id }) => ({
  ids: id
    ? {
      root: id,
      title: `${id}__title`,
      illustration: `${id}__illustration`,
      description: `${id}__description`,
      message: `${id}__message`,
      actionButton: `${id}__actionButton`,
      back: `${id}__back`,
      warning: `${id}__warning`,
    }
    : {},
})

const ErrorPage = (props) => {
  const {
    ids,
  } = props

  const mergedProps = props.defaultTemplate
    ? ({ ...codes[props.defaultTemplate], ...props })
    : props

  return (
    <View id={ids.root} style={{ alignItems: 'center', width: '100%', margin: 'auto', maxWidth: '500px' }}>
      <SpacerVertical extraLarge/>
      <View id={ids.illustration}>
        {mergedProps.illustration}
      </View>
      <SpacerVertical medium/>
      <View id={ids.title}>
        <TitlePrimary small centered>
          {mergedProps.title}
        </TitlePrimary>
      </View>
      <SpacerVertical small/>
      <View id={ids.description}>
        <ParagraphSecondary warning centered>
          {mergedProps.errorCode && `Error code: ${mergedProps.errorCode}`}
        </ParagraphSecondary>
      </View>
      <SpacerVertical small/>
      <View id={ids.message}>
        <ParagraphSecondary centered>
          {mergedProps.message}
        </ParagraphSecondary>
      </View>
      <SpacerVertical small/>
      {mergedProps.actionButton && Object.keys(mergedProps.actionButton).length > 0 && (
        <View id={ids.actionButton} style={{ alignItems: 'flex-start' }}>
          <SpacerVertical small/>
          <ButtonPrimary size="medium" icon={mergedProps.actionButton.icon} onClick={() => mergedProps.actionButton.onClick()}>
            {mergedProps.actionButton.label}
          </ButtonPrimary>
        </View>
      )}
      {mergedProps.hasGoBack && (
        <View id={ids.back} style={{ alignItems: 'flex-start' }}>
          <SpacerVertical small/>
          <ButtonSecondary size="medium" icon={IconBackNavigation} onClick={() => window.history.back()}>
            Back to previous page
          </ButtonSecondary>
        </View>
      )}
      {mergedProps.correlationId && (
        <View id={ids.warning} style={{ alignItems: 'flex-start' }}>
          <SpacerVertical medium/>
          <AlertBannerWarning icon content={`When contacting support, please supply the following correlation ID: ${mergedProps.correlationId}`}/>
        </View>
      )}
    </View>
  )
}

export default compose(
  setDisplayName('Error'),
  setPropTypes({
    errorCode: PropTypes.string,
    message: PropTypes.string,
    defaultTemplate: PropTypes.string,
    illustration: PropTypes.node,
    correlationId: PropTypes.string,
    title: PropTypes.string,
    hasGoBack: PropTypes.bool,
    actionButton: PropTypes.object,
  }),
  withProps(getIds),
  omitProps('id'),
)(ErrorPage)
